var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncomplete2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 5C16.215 5 5 16.215 5 30C5 43.785 16.215 55 30 55C43.785 55 55 43.785 55 30C55 16.215 43.785 5 30 5ZM30 50C18.9725 50 10 41.0275 10 30C10 18.9725 18.9725 10 30 10C41.0275 10 50 18.9725 50 30C50 41.0275 41.0275 50 30 50Z",
    fill: "#EDBA56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 12.915V30H47.085C47.0906 27.7548 46.6525 25.5306 45.7959 23.4552C44.9393 21.3798 43.681 19.4942 42.0934 17.9066C40.5058 16.3189 38.6202 15.0607 36.5448 14.2041C34.4694 13.3475 32.2452 12.9094 30 12.915Z",
    fill: "#EDBA56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncomplete2);
export default __webpack_public_path__ + "static/media/incomplete-2.555243e5f73d07940b07d8ef4a5b6c22.svg";
export { ForwardRef as ReactComponent };